import { checkPermission } from '@/router/guards.ts'

const SmsProviderModule = () => import('./SmsProviderModule.vue')
const SmsProviderIndex = () => import('./views/SmsProviderIndex.vue')
const DeliveryLogIndex = () => import('./views/DeliveryLogIndex.vue')

export const smsProviderRoute = {
  path: '/sms-providers',
  name: 'smsProvider',
  component: SmsProviderModule,
  meta: {
    title: 'SmsProviders',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'smsProvidersIndex',
      component: SmsProviderIndex,
      meta: {
        permission: 'sms_provider.manage',
      },
      beforeEnter: checkPermission('sms_provider.manage'),
    },
    {
      path: 'delivery-logs',
      name: 'smsProviderDeliveryLogsIndex',
      component: DeliveryLogIndex,
      meta: {
        permission: 'sms_provider.manage',
      },
      beforeEnter: checkPermission('sms_provider.manage'),
    },
  ],
}
